module.exports = __webpack_public_path__ + "img/zhushinu-qrcode.c1d96224.png";